import { api, ApiError } from "@/api/api";
import { StoryConfig } from "@/api/story-configs-types";
import { useQuery } from "@tanstack/react-query";

export function useStoryConfigById(configId?: string) {
  return useQuery<StoryConfig, ApiError>({
    queryKey: ["GET", "storyConfigs", ":configId", configId],
    queryFn: () => api.storyConfigs.configId.get(configId!),
    enabled: !!configId,
  });
}
